export default __webpack_public_path__ + "static/hero-illustration-e96a602b57685fe4833e3d30008d1efe.svg";